import React from "react";
import { FormattedMessage } from "react-intl";

import { trackEvent } from "../../utils/tracking";
import { TRACKING_EVENTS } from "../../utils/trackingDefinitions";

export const VippsButton = ({ href, target }) => {
	const handleClick = () => {
		trackEvent({
			event: TRACKING_EVENTS.COMMON.EVENT.USER_INTERACTION,
			target,
			key: "action",
			value: TRACKING_EVENTS.COMMON.EVENT.VIPPS_LOGIN_CLICKED,
		});

		window.location.href = href;
	};

	return (
		<a
			className="button vipps"
			onClick={handleClick}
			href="#"
			data-testid="login.vipps.button"
			style={{ textDecoration: "none" }}
		>
			<FormattedMessage
				id="KomID.login.Vipps.ContinueWith"
				defaultMessage="Fortsett med"
			/>
			<svg
				width="64"
				height="16"
				viewBox="0 0 64 16"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M64 3.83838C63.2798 1.09082 61.5312 0 59.1445 0C57.2109 0 54.7842 1.09082 54.7842 3.71729C54.7842 5.41406 55.9565 6.74756 57.8691 7.09131L59.6797 7.41406C60.2642 7.51953 60.6504 7.6792 60.895 7.88477C61.0229 7.99219 61.1118 8.11182 61.1704 8.24268C61.2363 8.39062 61.2637 8.55273 61.2637 8.72754C61.2637 9.43457 60.5024 9.83838 59.3711 9.83838C57.8901 9.83838 56.9644 9.31348 56.8203 7.83838L54.208 8.24268C54.6191 11.0908 57.1699 12.2627 59.4736 12.2627C61.6548 12.2627 63.979 11.0103 63.979 8.48486C63.979 6.76758 62.9297 5.51514 60.9756 5.15137L58.9805 4.78809C57.8691 4.58594 57.499 4.04053 57.499 3.51514C57.499 2.84814 58.2192 2.42432 59.2065 2.42432C60.4614 2.42432 61.3462 2.84814 61.3872 4.24219L64 3.83838ZM5.9248 8.16113L8.64014 0.302734H11.8281L7.09668 11.9595H4.73145L0 0.302734H3.18848L5.9248 8.16113ZM22.6084 3.63623C22.6084 4.56543 21.8677 5.21191 21.0039 5.21191C20.1396 5.21191 19.3994 4.56543 19.3994 3.63623C19.3994 2.70654 20.1396 2.06055 21.0039 2.06055C21.8677 2.06055 22.6084 2.70654 22.6084 3.63623ZM23.1016 7.75781C22.0317 9.13135 20.9004 10.0811 18.9048 10.0811C16.8691 10.0811 15.2847 8.86865 14.0503 7.09131C13.5566 6.36377 12.7954 6.20215 12.2397 6.58594C11.7256 6.94971 11.6025 7.71729 12.0757 8.38428C13.7827 10.9497 16.1484 12.4443 18.9048 12.4443C21.4355 12.4443 23.4102 11.2324 24.9531 9.2124C25.5288 8.46484 25.5083 7.69727 24.9531 7.27295C24.4385 6.86865 23.6772 7.01074 23.1016 7.75781ZM30.2002 6.10059C30.2002 8.48486 31.5991 9.7373 33.1626 9.7373C34.6436 9.7373 36.166 8.56543 36.166 6.10059C36.166 3.67627 34.6436 2.50488 33.1831 2.50488C31.5991 2.50488 30.2002 3.61572 30.2002 6.10059ZM30.2002 1.91943V0.322754H27.2998V16H30.2002V10.4238C31.167 11.7168 32.4219 12.2627 33.8413 12.2627C36.4951 12.2627 39.0869 10.2021 39.0869 5.95947C39.0869 1.89844 36.3921 0 34.0879 0C32.2573 0 31.0024 0.828125 30.2002 1.91943ZM44.1274 6.10059C44.1274 8.48486 45.5264 9.7373 47.0898 9.7373C48.5708 9.7373 50.0933 8.56543 50.0933 6.10059C50.0933 3.67627 48.5708 2.50488 47.1104 2.50488C45.5264 2.50488 44.1274 3.61572 44.1274 6.10059ZM44.1274 1.91943V0.322754H41.2271V16H44.1274V10.4238C45.0942 11.7168 46.3491 12.2627 47.7686 12.2627C50.4224 12.2627 53.0142 10.2021 53.0142 5.95947C53.0142 1.89844 50.3193 0 48.0151 0C46.1846 0 44.9297 0.828125 44.1274 1.91943Z"
					fill="white"
				/>
			</svg>
		</a>
	);
};
